import Mutations from '../../odata/mutations';

export default { ...new Mutations('quoteSection'), ...new Mutations('quoteSections') };
